import { z } from "zod";

export const TransferPaymentFineTypeEnum = {
  CURRENT_INSTALLMENT: "CURRENT_INSTALLMENT",
  NEXT_INSTALLMENT: "NEXT_INSTALLMENT",
  INSTALLMENT_PAYMENT: "INSTALLMENT_PAYMENT",
} as const;

export const transferPaymentFineTypeSchema = z.enum([
  TransferPaymentFineTypeEnum.CURRENT_INSTALLMENT,
  TransferPaymentFineTypeEnum.NEXT_INSTALLMENT,
  TransferPaymentFineTypeEnum.INSTALLMENT_PAYMENT,
]);

export type TransferPaymentFineType = z.infer<typeof transferPaymentFineTypeSchema>;